const getRemovedTagContent = content => {
    if (!content || typeof content !== 'string') return '';
    return content
        .replace(/<[^>]*>?/g, '')
        .replace(/<[^>]*$/g, '') 
        .replace(/&nbsp;/g, ' ') 
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\r\n/g, ' ')
        .replace(/\n/g, ' ')
        .replace(/\r/g, ' ')
        .replace(/\t/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

export { getRemovedTagContent };